import { component as defineComponent } from 'flightjs';

var entryAwardButton = function () {
    this.after('initialize', function () {
        this.on('click', this.triggerAwardEntry);
    });

    this.triggerAwardEntry = function (event) {
        var data = this.$node.data();
        if (this.$node.is('[data-disabled]')) {
            event.stopPropagation();
            return;
        }

        const designer = {
            avatarUrl: data.entryAwardDesignerAvatar,
            displayName: data.entryAwardDesigner,
        };

        const entry = {
            contestEntryId: data.entryAwardDesignId,
            hasPurchasableStock: parseInt(data.entryAwardDesignStockDeclarations, 10) > 0,
            imageUrl: data.entryAwardDesignImg,
            awardUrl: data.entryAwardUrl,
            user: designer,
        };

        window.dispatchEvent(new window.CustomEvent('openAwardWinnerModal', { detail: [entry] }));
    };
};

export default defineComponent(entryAwardButton);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/entry-award-button.js